import {
  Goal,
  HabitSortingMode,
  ID,
  LifeArea,
  lifeAreaOtherID,
  Task,
  WeekDays,
} from '@griply/types';

import { getSortedTasks } from './get-sorted-tasks';
import { GroupedTasks, groupTasksByLifeArea } from './group-tasks-by-life-area';
import { habitSortingModeToSortingMode } from './habit-sorting-mode-to-sorting-mode';

export type BuildLifeAreaHabitSectionsOptions = {
  habits: Task[];
  lifeAreas: LifeArea[];
  goals?: Goal[];
  lifeAreaSorting?: string[];
  habitSortingMode?: HabitSortingMode;
  habitGroupSorting?: Record<string, ID[]> | null;
  today: Date;
  weekStartsOn: WeekDays;
};

export const buildLifeAreaHabitSections = (
  options: BuildLifeAreaHabitSectionsOptions,
): GroupedTasks[] => {
  const {
    habits,
    lifeAreas,
    goals,
    lifeAreaSorting,
    habitSortingMode,
    habitGroupSorting,
    today,
    weekStartsOn,
  } = options;

  const groups = groupTasksByLifeArea({
    tasks: habits,
    lifeAreas,
    lifeAreaSorting,
    goals,
  });

  return groups.map<GroupedTasks>((group) => ({
    ...group,
    tasks: getSortedTasks(group.tasks, {
      today,
      weekStartsOn,
      mode: habitSortingMode
        ? [habitSortingModeToSortingMode[habitSortingMode]]
        : undefined,
      order:
        habitGroupSorting?.[
          group.lifeAreaId === lifeAreaOtherID ? 'null' : group.lifeAreaId
        ] ?? [],
    }),
  }));
};
